module.exports = __webpack_public_path__ + "img/wallet-grey.32b42ceb.svg";